module.exports = __webpack_public_path__ + "fonts/lineto-circular-book.woff2";